import React from "react";
import { paymentIcons } from "../data";
import s from "./OrderNowPayLater.module.scss";

type props = {
  className?: string;
  text?: string;
};

const OrderNowPayLater = ({ className = "", text }: props) => (
  <div className={`${s.paylater} ${className}`}>
    <div className={s.paylater__text}>{text}</div>
    <div className={s.paylater__payments}>
      {paymentIcons.map((icon, index) => (
        <img
          src={icon.img}
          key={index}
          alt={icon.alt}
          width={icon.width}
          height={icon.height}
        />
      ))}
    </div>
  </div>
);

export default OrderNowPayLater;
